<template>
  <div class="brands-section">
    <div class="card-wrapper">
      <b-card
        title="Capsule"
        sub-title="/kap-suh l, -sool, -syool/ n."
        class="shadow card-thing"
        data-aos="flip-right"
      >
        <p class="card-text">
          A collection of clothing made up of a few pieces which can easily be
          combined and interchanged.
        </p>
      </b-card>
    </div>
    <div class="brands-wrapper">
      <BrandsDisplay />
    </div>
  </div>
</template>

<script>
import BrandsDisplay from "@/components/brandsDisplay";
export default {
  components: {
    BrandsDisplay
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_breakpoints.scss";
@import "~@/styles/_colour-palette.scss";

.brands-section {
  margin-top: -50px;
  padding-top: 130px;
  padding-bottom: 30px;
  background: $grey5;
  position: relative;

  .brands-wrapper {
    margin-top: 20px;
    margin-bottom: 10px;

    @include for-tablet-portrait-up {
      margin-top: 10px;
      margin-bottom: 30px;
    }
  }

  .card-wrapper {
    .card-subtitle {
      margin-bottom: 20px !important;
    }
    .card-thing {
      position: absolute;
      max-width: 600px;
      top: -75px;
      left: 0%;
      margin-left: 15px;
      margin-right: 15px;

      @include for-tablet-portrait-up {
        left: 20%;
        margin-left: 0;
        margin-right: 0;
      }

      @include for-tablet-landscape-up {
        left: 35%;
      }

      @include for-desktop-up {
        left: 40%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/BrandsSection.vue